
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import Att_Helth_Status from './Att_Helth_Status';
import Modal from "react-bootstrap/Modal";
//import TimeCalculator from './TimeCalculate';
import { Space, TimePicker, DatePicker, showNow } from "antd";
import TimeSheetRequestModal from '../../Modal/TimeSheetRequestModal';
const user_login_id = localStorage.getItem('userId')
let token = JSON.parse(localStorage.getItem('key'));
let SERVER_URL = process.env.REACT_APP_API_URL;

function Attandence_list() {
    const [open,setOpen] = useState(false);
    const [outtime,setOuttime] = useState();
    const [Intime,setIntime] = useState();
    const [regularizedate,setRegularizedate] = useState();
    const [savebtn, setSavebtn] = useState(true);

    const handleOpenRegulariseModel = ()=>{
        setOpen(true)
    }
    const handleCloseRegulariseModel = ()=>{
        setOpen(false)
    }
    const HandleTimeOut = (time, timeString) => {
        setOuttime(moment(timeString, ["h:mm A"]).format("HH:mm"))
    };
    const HandleTimeIn = (time, timeString) => {
        setIntime(moment(timeString, ["h:mm A"]).format("HH:mm"))
    };
    const handleRegularize = (regdate) => {
        setRegularizedate(moment(regdate).format("YYYY-MM-DD"))
        //getUserTodaysAttendance(moment(regdate).format("YYYY-MM-DD"))

    }
    const [msg, setMsg] = useState('');
    const [err, setErr] = useState('');
    const [ErrdateMSG,setErrdateMSG] = useState('')
    const handleSubmit = () => {
        setErrdateMSG('')

        if (regularizedate === '' || regularizedate === null || regularizedate === undefined) {
            setErrdateMSG('Field is required');
            return false;
        } else {
            setSavebtn(false)
            const user_login_id = localStorage.getItem('userId')
            const response = fetch(SERVER_URL + `api/attendance/time-sheet-request`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        EmpID: user_login_id,
                        // attId: user_attendance_id,
                        // requestDate: regularizedate,
                        // requestType: requesttype,
                        // requestWorkType: workstatus,
                        // startTime: intime,
                        // endTime: outtime,
                        // requestReason: reason
                    }),
                }).then(res => res.json())
                .then(data => {
                    if (data.status === true) {
                        setErr('green')
                        setMsg('Your Timesheet request added Successfully')
                        setTimeout(function () {
                            setSavebtn(true)
                            handleCloseRegulariseModel()
                            setMsg('');
                        }, 1000);

                    } else {
                        setErr('red')
                        setMsg('Something Went Wrong')
                    }
                })
        }

    }
    return (
        <div className="container-fluid">
            <>
                <Modal show={open} size="md" id="confirm_login">
                    <div className="modal-body">
                        <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                            <i className="icon icon-cross"></i>
                        </button>
                        <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Time Log Summary </div>
                        <div className="mb-2">
                            
                        </div>
                    </div>
                </Modal>
            </>
            <TimeSheetRequestModal open={open} setOpen={setOpen} />
           
            <button className="btn_5 float-end"  onClick={handleOpenRegulariseModel} >Time Sheet Request</button>
           
            <div className="dash_ttl">
                Attendance
            </div>
            <div className="crumbs">
                <ul id="breadcrumbs" className="breadcrumb">
                    <li>
                        <a href="dashboard.html">Dashboard </a>
                    </li>
                    <li className="current">
                        <span>/</span>Attendance
                    </li>
                </ul>
            </div>
            <div className="row">
                <div className="col-md-5">
                    <div className="dash_white_box2 mb20 mh314">
                        <div className="dash_white_box_ttl">Statistics</div>
                        <div className="pun_cont_wrp">
                            <div className="punch_wrp mb15">
                                <div className="progress_ttl">
                                    Today
                                    <div className="progress_text">
                                        {/* {Today_Total_HRS ? Today_Total_HRS : '00'}:{Today_Total_MINUTS ? Today_Total_MINUTS : ''}/9 <span className="pro_hrs">hrs</span> */}
                                    </div>
                                </div>
                                <div className="progress_bar">
                                    {/* <div className="pro_b progress-cgreen" style={{ width: `${(((parseFloat(Today_Total_HRS * 60) + parseFloat(Today_Total_MINUTS)) * 1.7) / 9) + "%"}` }}></div> */}
                                </div>
                            </div>
                            <div className="punch_wrp">
                                <div className="progress_ttl">
                                    This Week

                                    <div className="progress_text">
                                        {/* {(Math.floor(week_total_HRS / 60) == 0 ? '00' : Math.floor(week_total_HRS / 60))}
                                        :{week_total_HRS % 60}/45 <span className="pro_hrs">hrs</span> */}
                                    </div>
                                </div>
                                <div className="progress_bar">
                                    {/* <div className="pro_b progress-red" style={{ width: `${((week_total_HRS * 1.7) / 45) + "%"}` }}></div> */}
                                </div>
                            </div>


                            <div className="punch_wrp">
                                <div className="progress_ttl">
                                    This Month
                                    <div className="progress_text">
                                        {/* {(Math.floor(month_total_HRS / 60) == 0 ? '00' : Math.floor(month_total_HRS / 60))}
                                        :{month_total_HRS % 60}
                                        /{daysinmonth ? (daysinmonth - countWeekOf) * 9 : ''} <span className="pro_hrs">hrs</span> */}
                                    </div>
                                </div>
                                <div className="progress_bar">
                                    {/* <div className="pro_b progress-orange" style={{ width: `${((month_total_HRS * 1.7) / 198) + "%"}` }}></div> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Monthly Summary</div>
                        <table className="monthly_table">
                            <thead>
                                <tr>
                                    {/* <th colSpan="2">Attendance : <b>1  {moment(new Date(year, month - 1)).format("MMM YYYY")}  {moment(year + '-' + month, "YYYY-MM").daysInMonth()} {moment(new Date(year, month - 1)).format("MMM YYYY")}</b></th> */}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }}>Present</td>
                                    <td>{'present'}</td>
                                </tr>
                                <tr>
                                    <td>Absent</td>
                                    {/* <td>{day - 1 - present - countweekofToday}</td> */}
                                </tr>
                                <tr>
                                    <td>Late In / Early Out</td>
                                    <td>--</td>
                                </tr>
                                <tr>
                                    <td>Leave</td>
                                    <td>--</td>
                                </tr>

                                <tr>
                                    <td>Weekly off </td>
                                    <td></td>
                                    {/* <td>{countWeekOf}</td> */}
                                </tr>
                                <tr>
                                    <td>Holiday</td>
                                    <td></td>
                                    {/* <td>{officeHolidays ? officeHolidays : ''}</td> */}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Current Day Status</div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='time_status_wrp'>
                                    <span>In Time</span>
                                    <span>10:30 AM</span>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='time_status_wrp'>
                                    <span>Out Time</span>
                                    <span>5:00 PM</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Approval Flow</div>
                        <p>Here you can see who will approve your attendance related requests</p>
                        <div className="approvalflow_wrp">
                            {/* <img src={`${SERVER_URL}userimages/${RMG_img ? RMG_img : RMG_gender == 1 ? 'm_user.png' : 'f_user.png'}`} alt="" /> */}
                            <div className="approvalflow_ttl mb20">
                                {/* <div>{RMGF} {RMGL}</div>
                                <div>Level : <span>Final</span> </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Attendance Sheet</div>
                        <ul className="calendar_listing">
                            <li className="calendar_listing_blk"><span className="absent"></span> Absent</li>
                            <li className="calendar_listing_blk"><span className="present"></span> Present</li>
                            <li className="calendar_listing_blk"><span className="weeklyoff"></span> Weekly Off</li>
                            <li className="calendar_listing_blk"><span className="holiday"></span> Holiday</li>
                            <li className="calendar_listing_blk"><span className="leave"></span> Leave</li>
                            <li className="calendar_listing_blk"><span className="outdoor"></span> Outdoor</li>
                            <li className="calendar_listing_blk"><span className="compoff"></span> Compoff</li>
                            <li className="calendar_listing_blk"><span className="halfday"></span> Half Day Present</li>
                            <li className="calendar_listing_blk"><span className="latein"></span> Late In - Early Out</li>
                            <li className="calendar_listing_blk"><span className="workhome"></span> Work From Home </li>
                        </ul>
                        <div className="mb20 float-end d-flex">
                            <select style={{ width: "100px" }} className="form-select mr05" value={1} >
                                <option value="">Select Year</option>
                                <option value="2022">2022</option>
                                <option value="2023">2023</option>
                                <option value="2024">2024</option>
                            </select>
                            <select style={{ width: "100px" }} className="form-select mr05" value={1} >
                                <option value="">Select Month</option>
                                <option value="1"> Jan </option>
                                <option value="2"> Feb </option>
                                <option value="3"> Mar </option>
                                <option value="4"> Apr </option>
                                <option value="5"> May </option>
                                <option value="6"> Jun </option>
                                <option value="7"> Jul </option>
                                <option value="8"> Aug </option>
                                <option value="9"> Sept </option>
                                <option value="10"> Oct </option>
                                <option value="11"> Nov </option>
                                <option value="12"> Dec </option>
                            </select>
                            {/* {hr_permission_arr?.includes('48') && (
                                <select style={{ width: "180px" }} className="form-select" onChange={e => setRole(e.target.value)} value={role} >
                                    <option value=" ">Select Role</option>
                                    {
                                        system_role?.map((item, ind) => (
                                            <option key={ind} value={item.id}>{item.role}</option>
                                        ))}
                                </select>
                            )}
                            {hr_permission_arr?.includes('48') && (

                                <select style={{ width: "180px" }} className="form-select" onChange={e => setUser(e.target.value)} value={user} >
                                    <option value=" ">Select User</option>
                                    {
                                        user_filetr?.map((item, ind) => {
                                            return <option value={item.user_id}>{item?.fname}{item?.mname ? ` ${item?.mname}` : ''}{item?.lname ? ` ${item?.lname}` : ''}</option>
                                        })
                                    }
                                </select>
                            )
                            } */}
                        </div>
                        {/* <h2 style={{ lineHeight: "46px" }} className="mb20"> {moment(new Date(year, month - 1)).format("MMM YYYY")}</h2> */}
                        <table className="table_style_2">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Attendance View </th>
                                    <th>Start Time</th>
                                    <th>Stop Time</th>
                                    <th>Total Hours</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                            
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>

        </div>
    )
}
export default Attandence_list

